import { useEffect } from "react";

const LoginpageVideo = () => {
//   useEffect(() => {
//     window.parent.postMessage(
//       { action: "redirectTo", label: "points-history" },
//       "*"
//     );
//   }, []);

  return (
    <iframe
      src="https://pmi-salesforce.videomarketingplatform.co/v.ihtml/player.html?token=0112a7200a0d571ee3f6f2def6d2a87f&source=embed&photo%5fid=118727227&endOn=thumbnail"
      width="100%"
      height="600"
      frameBorder="0"
      allowFullScreen
    ></iframe>
  );
};

export default LoginpageVideo;
